import { createTheme } from '@mui/material/styles';
import { theme as salooneDesign } from '../../../theme';

const { colors, typography } = salooneDesign;

const createSalooneAccessTheme = (direction = 'ltr') => createTheme({
  direction,
  palette: {
    primary: {
      ...colors.primary,
      main: colors.primary[600],
      light: colors.primary[300],
      dark: colors.primary[900],
      contrastText: '#ffffff',
    },
    secondary: {
      ...colors.secondary,
      main: colors.secondary[600],
      light: colors.secondary[300],
      dark: colors.secondary[900],
      contrastText: '#ffffff',
    },
    success: { ...colors.success, main: colors.success[600] },
    warning: { ...colors.warning, main: colors.warning[600] },
    error: { ...colors.error, main: colors.error[600] },
    info: { ...colors.info, main: colors.info[600] },
    background: {
      default: colors.secondary[50],
      paper: colors.background.primary,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
    divider: colors.primary[100],
  },
  typography: {
    fontFamily: typography.fontFamily.sans.join(', '),
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 700,
          textTransform: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          border: `1px solid ${colors.primary[100]}`,
          borderRadius: 18,
          boxShadow: '0 24px 70px rgba(107, 56, 26, 0.14)',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colors.primary[400],
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: colors.primary[400],
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primary[400],
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primary[600],
          },
        },
      },
    },
  },
});

export default createSalooneAccessTheme;
